export const loggedInUserSelector = (state: RootState) => state.auth.user;